import {Trans, useTranslation} from 'react-i18next';
import {useModalControls} from 'hooks';
import {useMatch} from 'react-router-dom';
import {useSummary} from 'context/summary';
import {COUNTRY_CODES} from 'utils/constants';
import QuestionMarkAndText from 'components/common/QuestionMarkAndText';
import {ModalSheetContainer, PrivacyPolicyLink, Modal} from './styled';

type Props = {
  className?: string;
};
export const TreatImagesInfoModal = ({className}: Props) => {
  const {countryCode, isLoading} = useSummary();
  const {t} = useTranslation();
  const {isOpen, openModal, closeModal} = useModalControls();
  const isFrontSideView = useMatch('/:token?/verification/front/*');
  const isBackSideView = useMatch('/:token?/verification/back/*');
  const isUploadingTypeView = useMatch('/:token?/verification/uploading-type/:type');
  const isVisible =
    countryCode === COUNTRY_CODES.spain &&
    !isLoading &&
    (isFrontSideView || isBackSideView || isUploadingTypeView);

  return (
    isVisible && (
      <>
        <QuestionMarkAndText
          className={className}
          text={t('why_do_we_ask_for_photos_during_the_process')}
          onClick={openModal}
          iconSize={19}
        />
        <Modal
          isOpenModalSheet={isOpen}
          handleCloseModal={closeModal}
          title={t('why_do_we_ask_for_photos_during_the_process')}
          closeOnDocumentClick
          withCloseButton
          padding
          closeButtonType="click"
        >
          <ModalSheetContainer>
            <Trans i18nKey="why_do_we_ask_for_photos_during_the_process_text">
              <PrivacyPolicyLink href={t('guest_privacy_policy_link')} />
            </Trans>
          </ModalSheetContainer>
        </Modal>
      </>
    )
  );
};
